import { Controller } from '@hotwired/stimulus';
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  LineController,
  LineElement,
  PointElement
} from "chart.js";

Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  LineController,
  LineElement,
  PointElement
);

const backgroundColors = [
  "rgba(66, 138, 124, 0.5)",
  "rgba(66, 138, 124, 0.5)",
  "rgba(66, 138, 124, 0.5)",
  "rgba(66, 138, 124, 0.5)",
  "rgba(66, 138, 124, 0.5)",
  "rgba(66, 138, 124, 0.5)",
  "rgba(66, 138, 124, 0.5)"
];
const borderColors = [
  "rgba(66, 138, 124, 1)",
  "rgba(66, 138, 124, 1)",
  "rgba(66, 138, 124, 1)",
  "rgba(66, 138, 124, 1)",
  "rgba(66, 138, 124, 1)",
  "rgba(66, 138, 124, 1)",
  "rgba(66, 138, 124, 1)"
];
const lineColor = "rgba(245, 184, 2, 1)";
const options = {
  legend: {
    display: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true
        }
      }
    ]
  }
};

export default class extends Controller {
  connect() {
    const stepCounts = JSON.parse(this.element.dataset.counts);
    const datasets = [
      {
        data: stepCounts,
        backgroundColor: backgroundColors,
        borderColor: borderColors,
        borderWidth: 1
      }
    ];
    let goals;
    if (this.element.dataset.goals != null) {
      goals = JSON.parse(this.element.dataset.goals);
      let pointStyle = ["line", "line", "line", "line", "line", "line", "line"];
      for (let i = 0; i < 7; i++) {
        if (stepCounts[i] >= goals[i] && stepCounts[i] != 0) {
          pointStyle[i] = "star";
        }
      }
      datasets.push({
        type: "line",
        data: goals,
        borderColor: lineColor,
        borderWidth: 4,
        fill: false,
        pointRadius: 8,
        pointStyle: pointStyle
      });
    }
    new Chart(this.element, {
      type: "bar",
      data: {
        labels: JSON.parse(this.element.dataset.labels),
        datasets: datasets
      },
      options: options
    });
  }
}
